
const BASE_URL = process.env.REACT_APP_BASE_URL;
const CCMS_VERSION = "s6";


export const searchApi = {
  allSuggestion: async (queryText) => {
    const urlEncodedQuery = encodeURIComponent(queryText);
    const suggestionResponse = await fetch(
      `${BASE_URL}/search/v1/${CCMS_VERSION}/combined/suggest?query=${urlEncodedQuery}`,
    );

    if (suggestionResponse.status !== 200) {
      throw new Error("Unable to hit combined search suggestion API");
    }
    return await suggestionResponse.json();
  },
  allAutocomplete: async (queryText) => {
    const urlEncodedQuery = encodeURIComponent(queryText);
    const suggestionResponse = await fetch(
      `${BASE_URL}/search/v1/${CCMS_VERSION}/combined/autocomplete?query=${urlEncodedQuery}`,
    );

    if (suggestionResponse.status !== 200) {
      throw new Error("Unable to hit combined search autocomplete API");
    }
    return await suggestionResponse.json();
  },
  combinedSearch: async (searchParams) => {
    const {
      searchText: query,
      top = 10,
      guidelineFacet = undefined,
      sortBy = "relevance",
      skip = 0,
    } = searchParams;

    const searchUrl = new URL(`${BASE_URL}/search/v1/${CCMS_VERSION}/combined`);
    searchUrl.searchParams.append("query", query);
    searchUrl.searchParams.append("top", top);
    if (guidelineFacet) {
      searchUrl.searchParams.append("guidelineFacet", guidelineFacet);
    }
    searchUrl.searchParams.append("sortBy", sortBy);
    searchUrl.searchParams.append("skip", skip);

    const suggestionResponse = await fetch(searchUrl.href);

    if (suggestionResponse.status !== 200) {
      throw new Error("Unable to hit combined search API");
    }
    return await suggestionResponse.json();
  },
  drugSearchSuggestion: async (queryText) => {
    const urlEncodedQuery = encodeURIComponent(queryText);
    const suggestionResponse = await fetch(
      `${BASE_URL}/search/v1/${CCMS_VERSION}/drug/suggest?query=${urlEncodedQuery}`,
    );

    if (suggestionResponse.status !== 200) {
      throw new Error("Unable to hit search suggestion API");
    }
    return await suggestionResponse.json();
  },
  drugSearchAutocomplete: async (queryText) => {
    const urlEncodedQuery = encodeURIComponent(queryText);
    const suggestionResponse = await fetch(
      `${BASE_URL}/search/v1/${CCMS_VERSION}/drug/autocomplete?query=${urlEncodedQuery}`,
    );

    if (suggestionResponse.status !== 200) {
      throw new Error("Unable to hit combined search autocomplete API");
    }
    return await suggestionResponse.json();
  },

  drugSearch: async (searchParams) => {
    const { searchText: query, sortBy = "relevance" } = searchParams;

    const searchUrl = new URL(`${BASE_URL}/search/v1/${CCMS_VERSION}/drug`);
    searchUrl.searchParams.append("query", query);
    searchUrl.searchParams.append("sortBy", sortBy);

    const drugSearchResponse = await fetch(searchUrl.href);

    if (drugSearchResponse.status !== 200) {
      throw new Error("Unable to hit drug search API");
    }
    return await drugSearchResponse.json();
  },
};
